import { MinusCircleIcon } from '@phosphor-icons/react';
import { Thumbnail } from '@/components';
import {
    CameraCreationItem,
    CameraConnectionStatus,
    ConnectionStatus,
} from '@/types/camera';
import { CameraStatusBadge } from '@/components/CameraStatusBadge';

interface CameraItemProps {
    camera: CameraCreationItem;
    isActive: boolean;
    onSelect: () => void;
    onDelete: () => void;
    canDelete: boolean;
    connectionStatus?: CameraConnectionStatus;
}

export function CameraMenuItem({
    camera,
    isActive,
    onSelect,
    onDelete,
    canDelete,
    connectionStatus,
}: CameraItemProps) {
    return (
        <div
            className={`
        group flex items-center gap-2 p-1.5 rounded-[8px] cursor-pointer transition-colors
        ${isActive ? 'bg-grey-600' : 'hover:bg-grey-550'}
      `}
            onClick={onSelect}
        >
            <div className="shrink-0 overflow-hidden rounded-[2px]">
                {connectionStatus?.snapshot ? (
                    <img
                        src={`data:image/jpeg;base64,${connectionStatus.snapshot}`}
                        alt={camera.name}
                        className="h-9 w-16 object-cover"
                    />
                ) : (
                    <Thumbnail
                        variant="placeholder"
                        compact
                        aria-label={camera.name}
                    />
                )}
            </div>

            <div className="flex-1 min-w-0">
                <p
                    className={`text-xs font-normal truncate ${isActive ? 'text-white-100' : 'text-grey-200'}`}
                >
                    {camera.name}
                </p>
            </div>

            <div className="flex items-center gap-2">
                <CameraStatusBadge
                    status={connectionStatus?.status}
                    loading={
                        connectionStatus?.status === ConnectionStatus.TESTING
                    }
                />

                {canDelete && (
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete();
                        }}
                        className={`flex-shrink-0 text-grey-200 hover:text-grey-100 transition-colors ${
                            isActive
                                ? 'opacity-100'
                                : 'opacity-0 group-hover:opacity-100'
                        }`}
                        aria-label="Remove camera"
                    >
                        <MinusCircleIcon className="w-4 h-4" />
                    </button>
                )}

                {!canDelete && <div className="w-4 h-4 flex-shrink-0" />}
            </div>
        </div>
    );
}
